<template>
  <div class="columns">
    <div class="column">
      <sc-dropdown ref="filtersDropdown" class="contract__filters-dropdown">
        <div class="field" slot="trigger">
          <div class="control has-icons-left has-icons-right">
            <sc-icon class="is-left" icon="table" />
            <button type="button" v-html="labelSelect" class="button input has-icons-left has-text-left is-fullwidth" />
            <sc-icon class="is-right" icon="angle-down" />
          </div>
        </div>
        <sc-dropdown-item custom paddingless>
          <sc-card class="contract__card">
            <template slot="body">
              <div class="contract__filters-dropdown-content" v-for="ec in listContractFilter">
                <sc-field :label="ec.name" v-if="ec.list.length" />
                <sc-field v-for="(lc, i) in ec.list" :key="i">
                  <sc-checkbox size="is-small" @input="toggleContract($event, contract.id)" v-model="add_contracts" :native-value="lc">
                    #ID {{ lc.id }} - {{ lc.file_name }}
                  </sc-checkbox>
                </sc-field>
              </div>
            </template>
            <template slot="footer">
              <div class="contract__filters-dropdown-footer">
                <sc-button @click="closeFilters" theme="default" ref="filtersDropdown" text="Fechar" />
              </div>
            </template>
          </sc-card>
        </sc-dropdown-item>
      </sc-dropdown>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScCheckbox,
  ScField,
  ScDropdown,
  ScIcon,
  ScDropdownItem,
  ScCard,
  ScButton,
} from '@intelipost-js/secure-components';
import EnumStatusList from '../../enums/EnumContractStatus';

const {
  mapGetters,
  mapActions,
} = createNamespacedHelpers('quote/freightQuote');

export default {
  name: 'sc-contract',
  props: {
    contract: Object,
  },
  data() {
    return {
      add_contracts: [],
      list_contract: [],
    };
  },
  computed: {
    ...mapGetters([
      'listContractId',
    ]),
    listContractFilter() {
      return EnumStatusList.map(e => ({ ...e,
        list: this.contract[e.default_name],
      }));
    },
    labelSelect() {
      let label = 'Tabelas ';

      this.add_contracts.forEach((a) => {
        label += ` <span class="contract__tag">#ID ${a.id} - ${a.file_name}</span>`;
      });

      return label;
    },
  },
  methods: {
    ...mapActions([
      'updateContractList',
    ]),
    toggleContract($event, id) {
      this.updateContractList({ contract_id: id, list: $event.map(e => e.id) });
    },
    closeFilters() {
      const {
        filtersDropdown,
      } = this.$refs;
      if (filtersDropdown) filtersDropdown.toggle();
    },
  },
  components: {
    ScCheckbox,
    ScField,
    ScDropdown,
    ScIcon,
    ScDropdownItem,
    ScCard,
    ScButton,
  },
};
</script>

<style lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line
.contract {
  &__result-column {
    overflow-x: auto;
    .table-wrapper {
      max-height: 400px;
      overflow-y: auto;
    }
  }
  &__card {
    box-shadow: none;
  }
  &__tag {
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 2px 5px;
    border-radius: 3px;
    display: inline-block;
    position: relative;
    font-size: 10px;
  }
  &__filters-dropdown {
    width: 100%;
    display: block;
    .dropdown-menu {
      width: 100%;
      z-index: 9;
    }
  }
  &__filters-dropdown-content {
    max-height: 15rem;
    overflow-y: auto;
    margin-bottom: 10px;
  }
  &__filters-dropdown-footer {
    background-color: $white-ter;
    border-top: 1px solid #e7e7e7;
    padding: 1.25rem;
    border-radius: 0 0 5px 5px;
    flex: 1;
    text-align: right;
    margin-bottom: -7px;
  }
}

.dropdown-list__item__checkbox {
  margin-right: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-contract/ScContract.vue?e4006858